import classNames from 'classnames/bind';

import CustomButton from '../../Buttons/CustomButton';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export function SubscriptionsManagement({ planName, className }) {
  return (
    <div className={`${Styles.plan_info} ${className}`}>
      <div className={Styles.message}>
        You are subscribed to the&nbsp;
        <span className={Styles.plan_name}>{planName}</span>
        &nbsp;plan.
        <br />
        If you would like to make any changes to your plan,
        <div className={cx('subscribe_button', 'text-center')}>
          <CustomButton type="blue" href="/preferences/subscription">
            Go to Subscription page
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

SubscriptionsManagement.defaultProps = {
  planName: '',
  className: '',
};

export default withComponentName(SubscriptionsManagement);
